import { FormFieldMapType } from '../../@types';

import { TokenexFieldMap } from './TokenexFieldMap';
import { StripeFieldMap } from './StripeFieldMap';
import { ContactFieldMap } from './ContactFieldMap';
import { BillingFieldMap } from './BillingFieldMap';

const StripeFormFieldMap: FormFieldMapType = {
  cardFields: StripeFieldMap,
  contactFields: ContactFieldMap,
  billingFields: BillingFieldMap,
};

const TokenexFormFieldMap: FormFieldMapType = {
  cardFields: TokenexFieldMap,
  contactFields: ContactFieldMap,
  billingFields: BillingFieldMap,
};

export function getFormFieldMap(isTokenex = false): FormFieldMapType {
  return isTokenex ? TokenexFormFieldMap : StripeFormFieldMap;
}
